/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeZakatDatePostRequestSchema } from './changeZakatDatePostRequestSchema.ts';
import { changeZakatDatePostResponseSchema } from './changeZakatDatePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangeZakatDate200Schema = z.lazy(() => changeZakatDatePostResponseSchema);

/**
 * @description 505 response
 */
export const postChangeZakatDate505Schema = z.any();

export const postChangeZakatDateMutationRequestSchema = z.lazy(() => changeZakatDatePostRequestSchema);

export const postChangeZakatDateMutationResponseSchema = z.lazy(() => postChangeZakatDate200Schema);
